import { inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { filter, first, forkJoin, map, of, switchMap, take } from "rxjs";
import { getUser } from "./store/actions/user.actions";
import {
    getMyClientAccounts,
    myClientAccountsLoaded,
} from "./store/actions/client-account.actions";
import { selectUserInfo } from "./store/selectors/user.selectors";

export const initialDepsResolver = () => {
    const store = inject(Store)

    // TODO : add global state instead of dispatching two actions
    store.dispatch(getMyClientAccounts());
    /** load user infos for store */
    const userInfosLoaded$ = store.select(selectUserInfo).pipe(
        take(1),
        switchMap((userInfos) => {
            if (userInfos) {
                return of(userInfos);
            }

            store.dispatch(getUser());
            return store.select(selectUserInfo).pipe(
                filter((loadedUserInfos) => !!loadedUserInfos),
                first(),
            );
        }),
    );
    /** load client accounts values */
    const myClientAccountsInfosLoaded$ = store.select(myClientAccountsLoaded).pipe(
        filter((myClientAccounts) => !!myClientAccounts),
        first(),
    );

    /**  fork join multiple API endpoint calls to wait all of them to finish */
    return forkJoin([userInfosLoaded$, myClientAccountsInfosLoaded$]).pipe(map(() => 'DEPS Loaded successfully !'));
};
